import React from "react";
import { Link } from "react-router-dom";
import "./CorePrinciples.css";
import corePrinciplesData from "./corePrinciplesData";

const CorePrinciples = () => {
  return (
    <section className="core-principles">
      <div className="core-container">
        <h2 className="core-heading">Our Core Principles</h2>
        <p className="core-subheading">
          The values that guide our engineering excellence.
        </p>

        <div className="core-grid">
          {corePrinciplesData.map((item) => (
            <div className="core-card" key={item.id}>
              <img src={item.image} alt={item.title} />

              <div className="core-content">
                <h3>{item.title}</h3>
                <p>{item.shortDescription}</p>

                {/* SPACE FIXED */}
                {/* <Link
                  to={`/principles/${item.slug}`}
                  className="core-btn"
                >
                  Read More →
                </Link> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorePrinciples;
